/*
登記所備付地図レイヤーの描画色
タイル描画（RegistrationMapTileLayer）と凡例（Legend）の両方で同じ色を使うので、
ここにまとめておいて変更が片側にしか反映されない事故を防ぐ
*/

import { toRgba } from "@/features/map/utils/toRgba";

// 筆界（地番ポリゴン）の枠線。役所地番地図（ピンク系）と並べても見分けられるよう青系にする
export const REGISTRATION_MAP_PARCEL_STROKE_COLOR = "#145ca8";
export const REGISTRATION_MAP_PARCEL_STROKE_OPACITY = 0.9;

// 対応エリアの塗り（地図を縮小したときに表示する）
export const REGISTRATION_MAP_COVERAGE_FILL_COLOR = "#2474d2";
export const REGISTRATION_MAP_COVERAGE_FILL_OPACITY = 0.5;

/** 凡例用の筆界色（地図上の見た目＝線色×不透明度と一致させる） */
export const REGISTRATION_MAP_PARCEL_STROKE_LEGEND_COLOR = toRgba(
  REGISTRATION_MAP_PARCEL_STROKE_COLOR,
  REGISTRATION_MAP_PARCEL_STROKE_OPACITY
);

/** 凡例用の対応エリア色（地図上の見た目＝塗り色×不透明度と一致させる） */
export const REGISTRATION_MAP_COVERAGE_LEGEND_COLOR = toRgba(
  REGISTRATION_MAP_COVERAGE_FILL_COLOR,
  REGISTRATION_MAP_COVERAGE_FILL_OPACITY
);
